// /stores/user.js
import { defineStore } from "pinia";
import userService from "@/api/userService";
import { useAuthStore } from "./auth";

export const useUserStore = defineStore("user", {
  state: () => ({
    profile: null,
    allUsers: [],
  }),
  actions: {
    async fetchUserProfile() {
      try {
        const { data } = await userService.getUserProfile();
        console.log("My user profile", data);
        this.profile = data;
        localStorage.setItem("is_gmail_authorized", data.is_gmail_authorized);
        localStorage.setItem(
          "is_outlook_authorized",
          data.is_outlook_authorized
        );
        localStorage.setItem("is_email_authorized", data.is_email_authorized);
        localStorage.setItem("is_email_verified", data.is_email_verified);
        localStorage.setItem("is_phone_verified", data.is_phone_verified);

        const authStore = useAuthStore();

        authStore.isPhoneVerified = data.is_phone_verified;
        authStore.isEmailVerified = data.is_email_verified;
        authStore.isGmailAuthorized = data.is_gmail_authorized;
        authStore.isOutlookAuthorized = data.is_outlook_authorized;
        authStore.isEmailAuthorized = data.is_email_authorized;
      } catch (error) {
        // Handle error
        console.error("Failed to fetch user profile:", error);
        throw error;
      }
    },
    async fetchAllUsers() {
      try {
        const { data } = await userService.getAllUsers();
        console.log("All users:", data);
        this.allUsers = data;
      } catch (error) {
        console.error("Failed to fetch all users:", error);
        throw error;
      }
    },
    async updateUserProfile(updatedData) {
      try {
        const { data } = await userService.updateUserProfile(updatedData);
        console.log("User profile updated:", data);
        this.profile = data; // Update the local profile state
      } catch (error) {
        console.error("Failed to update user profile:", error);
        throw error.response.data.detail[0];
      }
    },
    async uploadProfileImage(imageData) {
      try {
        const { data } = await userService.uploadProfileImage(imageData);
        console.log("Profile image uploaded:", data);
      } catch (error) {
        console.error("Failed to upload profile image:", error);
        throw error;
      }
    },
    async removeProfileImage() {
      try {
        const { data } = await userService.removeProfileImage();
        console.log("Profile image removed:", data);
      } catch (error) {
        console.error("Failed to remove profile image:", error);
        throw error;
      }
    },
    async submitContactMessage(messageData) {
      try {
        const { data } = await userService.submitContactMessage(messageData);
        console.log("Contact message submitted:", data);
      } catch (error) {
        console.log(error);
        // Handle error
        console.error("Failed to submit contact message:", error);
        throw error.response.data.detail[0];
      }
    },
  },
});
